import { render, staticRenderFns } from "./ProjectDocumentDetailsListing.vue?vue&type=template&id=0a527778&"
import script from "./ProjectDocumentDetailsListing.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentDetailsListing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDocumentDetailsListing.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProjectDocumentDetailsListing.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports